import OverlayBase from 'stimulus/overlay_base';

// Hamburger behaviour for the mobile company navbar: the full-screen menu is a modal overlay,
// so it gets the shared scroll lock, focus trap, Escape and focus restore from OverlayBase. The
// controller sits on the whole navbar because the toggle lives in the bar, outside the overlay.
export default class extends OverlayBase {
  static targets = ['overlay', 'toggle'];

  get surface() {
    return this.overlayTarget;
  }

  get panel() {
    return this.overlayTarget;
  }

  connect() {
    super.connect();
    // The kit IconButton doesn't render aria-expanded; own it from here.
    this.toggleTarget.setAttribute('aria-expanded', String(!this.surface.hidden));
  }

  open() {
    super.open();
    this.toggleTarget.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.dismiss();
  }

  dismiss() {
    if (this.surface.hidden) return;

    this.finishClose();
  }

  finishClose() {
    super.finishClose();
    this.toggleTarget.setAttribute('aria-expanded', 'false');
  }
}
